import styled from 'styled-components';

export const IFrame = styled.iframe<{ height?: any }>`
  width: 100%;
  border: none;
  border-radius: 0.5rem;
  min-height: ${({ height }) => (height ? `${height}px` : '800px')};
`;

export const Content = styled.div `
    margin: 0 0 25px 0;
`;
